module.exports = __webpack_public_path__ + "img/hbczsbhgzc_position_img.a986f494.png";